<template>
  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ message }}</div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

const message = ref('');
let clearTimer: number | undefined;

function handleAnnouncement(event: Event) {
  const nextMessage = (event as CustomEvent<string>).detail;
  if (!nextMessage) return;
  message.value = '';
  window.clearTimeout(clearTimer);
  clearTimer = window.setTimeout(() => {
    message.value = nextMessage;
  }, 50);
}

onMounted(() => window.addEventListener('app:announce', handleAnnouncement));
onBeforeUnmount(() => {
  window.removeEventListener('app:announce', handleAnnouncement);
  window.clearTimeout(clearTimer);
});
</script>
